var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#9D9D9D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_699_28676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.43 18.7282C21.43 19.0864 21.2876 19.43 21.0343 19.6834C20.781 19.9367 20.4374 20.079 20.0791 20.079H7.92119C7.56291 20.079 7.21931 19.9367 6.96598 19.6834C6.71264 19.43 6.57031 19.0864 6.57031 18.7282V11.2983C6.57031 10.9401 6.71264 10.5965 6.96598 10.3431C7.21931 10.0898 7.56291 9.94746 7.92119 9.94746H10.6229L11.9738 7.92114H16.0265L17.3773 9.94746H20.0791C20.4374 9.94746 20.781 10.0898 21.0343 10.3431C21.2876 10.5965 21.43 10.9401 21.43 11.2983V18.7282Z",
    fill: "#D9D9D9",
    stroke: "#9D9D9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9986 17.3771C15.4908 17.3771 16.7004 16.1675 16.7004 14.6754C16.7004 13.1832 15.4908 11.9736 13.9986 11.9736C12.5065 11.9736 11.2969 13.1832 11.2969 14.6754C11.2969 16.1675 12.5065 17.3771 13.9986 17.3771Z",
    fill: "white",
    stroke: "#9D9D9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_699_28676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2105,
    height: 16.2105,
    fill: "white",
    transform: "translate(5.89453 5.89478)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCamera);
export default __webpack_public_path__ + "static/media/circle_camera.c57b8252368a5e05e8a002e2503b0d37.svg";
export { ForwardRef as ReactComponent };